export default "__VITE_ASSET__B4kH$PMW__"